export default "__VITE_ASSET__BKX1GzIa__"